import { FC, useLayoutEffect, useRef, useState } from 'react';

import { withStaticProperties } from '../../lib/withStaticProperties';

import { INNER_BORDER_WIDTH } from './Input.constants';
import { InputWrapper, StyledInput, StyledLabel } from './Input.ui';
import {
  BasicInput,
  BasicInputProps,
} from './components/BasicInput/BasicInput';
import {
  Root,
  PostfixIconWrapper,
  PrefixIconWrapper,
} from './components/BasicInput/BasicInput.ui';

type GeneralInputProps = Omit<BasicInputProps, 'rootStyle'> & {
  isInvalid?: boolean;
  label?: string;
};

const GeneralInput: FC<GeneralInputProps> = (props) => {
  const {
    isInvalid,
    prefixIcon,
    postfixIcon,
    ref,
    inputStyle,
    inputClassName,
    rootClassName,
    label,
    ...inputProps
  } = props;

  const [paddingLeft, setPaddingLeft] = useState<number | undefined>();
  const [paddingRight, setPaddingRight] = useState<number | undefined>();

  const prefixIconRef = useRef<HTMLDivElement>(null);
  const postfixIconRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if (prefixIcon && prefixIconRef.current) {
      setPaddingLeft(prefixIconRef.current.clientWidth + INNER_BORDER_WIDTH);
    } else {
      setPaddingLeft(undefined);
    }
  }, [prefixIcon]);

  useLayoutEffect(() => {
    if (postfixIcon && postfixIconRef.current) {
      setPaddingRight(postfixIconRef.current.clientWidth + INNER_BORDER_WIDTH);
    } else {
      setPaddingRight(undefined);
    }
  }, [postfixIcon]);

  return (
    <InputWrapper className={rootClassName}>
      {label && <StyledLabel>{label}</StyledLabel>}

      <Root>
        {prefixIcon ? (
          <PrefixIconWrapper
            ref={prefixIconRef}
            innerIndent={INNER_BORDER_WIDTH}
          >
            {prefixIcon}
          </PrefixIconWrapper>
        ) : null}

        <StyledInput
          {...inputProps}
          className={inputClassName}
          isInvalid={isInvalid}
          ref={ref}
          style={{ ...inputStyle, paddingLeft, paddingRight }}
        />

        {postfixIcon ? (
          <PostfixIconWrapper
            ref={postfixIconRef}
            innerIndent={INNER_BORDER_WIDTH}
          >
            {postfixIcon}
          </PostfixIconWrapper>
        ) : null}
      </Root>
    </InputWrapper>
  );
};

const Input = withStaticProperties(GeneralInput, {
  Basic: BasicInput,
});

Input.displayName = 'Input';

export { Input };
